var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftArrowOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 23",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.304 22.857L.104 11.434 11.314 0l2.352 2.399-8.86 9.036 8.849 9.024-2.352 2.398"
  })));
}

export default __webpack_public_path__ + "media/images/consumer/pages/recipes/left-arrow-on-0f7dd3973f4b63436c8cd64a770a5f7f.svg";
export { SvgLeftArrowOn as Component };